import { ComponentProps, CSSProperties, FC, ReactNode } from "react";
import type { Link } from "react-router-dom";

/* eslint import/namespace: ['error', { allowComputed: true }] */
import * as cards from "components/Cards";
import { ClassName, Condition, OrString, ValueOrArray } from "config/types";

export type CardActions = {
  onClick?: (event: any) => void;
};

type Content = OrString<ComponentProps<any>>;

export interface ICardProps {
  content?: Condition<ValueOrArray<Content | Condition<Content>>>;
  className?: ClassName;
  conditions?: Condition;
  to?: ComponentProps<typeof Link>["to"];
  actions?: CardActions;
  style?: CSSProperties;
}

interface IProps extends ICardProps {
  as: keyof typeof cards;
  children?: ReactNode;
}

export const Card: FC<IProps> = ({ as, children, content = {}, conditions = {}, ...rest }) => {
  const CardBody = cards[as] as FC<ICardProps & { children?: ReactNode }>;

  return (
    <div className="card--container">
      <div className="card--wrapper">
        <CardBody content={content} conditions={conditions} {...rest}>
          {children}
        </CardBody>
      </div>
    </div>
  );
};
